export const environment = {
  production: true,
  apiUrl:'',
  baseUrl: '/',
  mapKey: 'AIzaSyD6emsHoKqSzFPnHJG8Kyf6T9PcDBIf4pQ'
};
